import { createFileRoute } from '@tanstack/react-router'
import { PortalJobScreen } from '../../features/portal/job'

export const Route = createFileRoute('/portal/jobs/$id')({
  component: JobRoute,
})

function JobRoute() {
  const { id } = Route.useParams()
  return <PortalJobScreen id={id} />
}
